import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import ContentBox from '../../layout/ContentBox';
import EvaluationOverview from '../../survey/evaluation/EvaluationOverview';
import SectionEvaluation from '../../survey/evaluation/SectionEvaluation';

const EvaluationSection = (props) => {
  const {
    trial, evaluation, excludedQuestions, EvaluationSecIndex,
  } = props;
  return (
    <>
      <ContentBox
        title={(
          <FormattedMessage
            id="enrollmentsmanager.detailedEvaluation"
            values={{ trial: trial.name }}
          />
        )}
      >
        <EvaluationOverview
          evaluationOverview={evaluation.overview}
          points={evaluation.points}
          pointIndex={EvaluationSecIndex}
          hideIndividualScores={trial.hideIndividualScores || !evaluation.points}
          evaluationType={trial.survey?.evaluationType}
        />
      </ContentBox>
      <h2>{evaluation.sectionEvaluations[EvaluationSecIndex].headline}</h2>
      <SectionEvaluation
        key={`evaluationSection-${EvaluationSecIndex}`}
        section={evaluation.sectionEvaluations[EvaluationSecIndex]}
        excludedQuestionSection={excludedQuestions[EvaluationSecIndex]}
      />
    </>
  );
};

EvaluationSection.defaultProps = {
  excludedQuestions: undefined,
};

EvaluationSection.propTypes = {
  trial: PropTypes.object.isRequired,
  evaluation: PropTypes.object.isRequired,
  excludedQuestions: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.number,
  ]),
  EvaluationSecIndex: PropTypes.number.isRequired,
};

export default EvaluationSection;
